<template>
    <statistiche-squadre-component/>
</template>

<script>
export default {
  data() {
    return {
      alertType: null,
      message: null,
      isLoading: null,
    };
  },
};
</script>